// import { useParams, useNavigate,Link ,useLocation} from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import './InstanceForm.css';
// import ContactDetails from '../contact/ContactDetails';
// import TenantList from '../tenant/TenantList';
// import InstanceView from './InstanceView';
// import DocumentDetails from '../DocumentDetails';
// import { useAuth } from '../../context/AuthContext';
// import withPermission from '../../utils/withPermission';
// import SelectedContact from './../contact/SelectedContact';
// import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
// import { BiPencil } from "react-icons/bi";
// import { BsChevronLeft } from "react-icons/bs"; 
// import InstanceForm from './InstanceForm';
// const InstanceDetail = () => {
//     const { id } = useParams(); // Get instance ID from the URL
//     const navigate = useNavigate();
//     const location = useLocation();
    
//     const [instanceDetails, setInstanceDetails] = useState(null);
//     const [activeTab, setActiveTab] = useState('tenantList');
//     const { permissions } = useAuth();
//     const WithTenanatPermission = withPermission(({ children }) => children, ['tenant-list']);
//     const didFetchRef = useRef(false); // Use ref to track whether the API has been called
//     const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
//     const WithDocumentPermission = withPermission(({ children }) => children, ['document-list']);
//     const queryParams = new URLSearchParams(location.search);
//     const initialTab = queryParams.get("activeTab") ||"tenantList"
//     const [selectedInstance, setSelectedInstance] = useState(null);
//         const [showModal, setShowModal] = useState(false);
//         const [instances, setInstances] = useState([]);
    
//     const fetchInstanceDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/instance-info/${id}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });

//             setInstanceDetails(response.data); // Set the fetched data to state
//         } catch (error) {
//             console.error('Error fetching instance details:', error);
//         }
//     };
//     const editInstance = async (instanceId, updatedData) => {
       
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.put(`${backendUrl}/api/instance-info/${instanceId}`, updatedData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });
//             const updatedInstance = response.data?.Data;

//             if (updatedInstance) {
//                 setInstanceDetails((prevLead) => ({
//                     ...prevLead,
//                     ...updatedInstance, // Merge updated data
//                 }));
//                 setInstances((prevInstances) =>
//                     prevInstances.map((instance) =>
//                         instance.id === updatedInstance.id ? updatedInstance : instance
//                     )
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             setShowModal(false);
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else {
//                 console.error('Error updating instance:', error);
//             }
//         }
//     };

//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchInstanceDetails(); // Only fetch data if it hasn't been done before
//             didFetchRef.current = true; // Mark that data has been fetched
//         }
//     }, [id]); // This will run only when `id` changes

//     useEffect(() => {
//         const queryParams = new URLSearchParams(location.search);
//         const activeTabParam = queryParams.get("activeTab") || "tenantList"; // Default to 'tenantInfo'
//         setActiveTab(activeTabParam); // Set the active tab based on URL parameter
//       }, [location.search]);
//     const handleBackClick = () => {
//         navigate(-1);
//     };

//     // Handle tab click to change active tab
//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//         navigate(`${location.pathname}?activeTab=${tab}`);
//     };

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Page Title */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                             <h4 className="mb-sm-0 d-flex align-items-center first-title">
//                                     <BsChevronLeft
//                                         className='back-button1'
//                                         onClick={() => navigate(-1)}
//                                     />
//                                     <span>Instance</span>
//                                 </h4>                                
//                                 <div className="page-title-right br-font">
//                                     <ol className="breadcrumb m-0">
//                                         <li className="breadcrumb-item"><Link to={`/instance/details/${id}?activeTab=instanceInfo`}>
//                                             {instanceDetails?.setup_name || " Instance Details"}
//                                         </Link></li>
//                                         <li className="breadcrumb-item active">Details</li>
//                                     </ol>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="p-6 max-w-7xl mx-auto">
//                     <>
//                             <Card className="mb-4 shadow-lg rounded-3 p-2 border-0 card-bg ">
//                                 {/* Header Section with Name and Edit Icon */}
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <Card.Title className="fw-bold font-size-14 text-primary">{instanceDetails?.setup_name}</Card.Title>
//                                     <BiPencil
//                                         className="text-primary hover-effect2 edit-pencil"
//                                         onClick={() => {
//                                             setSelectedInstance(instanceDetails); // Store organisation details
//                                             setShowModal(true); // Open modal
//                                         }} />
//                                 </div>
//                                 <Card.Body className="pt-3">
//                                     <div className="row">
//                                         {/* Left Section */}
//                                         <div className="col-md-6 ">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Setup ID:</strong></span>
//                                                 <span className=" text-muted card-value">{instanceDetails?.setup_id || '-'}</span>
//                                             </div>
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Setup Mode:</strong></span>
//                                                 <span className=" text-muted card-value">{instanceDetails?.setup_mode || '-'}</span>
//                                             </div>
//                                         </div>

//                                         {/* Right Section */}
//                                         <div className="col-md-4 ">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Address:</strong></span>
//                                                 <span className="fw-semibold text-primary card-value">{instanceDetails?.address || ''}</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                             {showModal && (
//                                 <InstanceForm
//                                     showModal={showModal}
//                                     handleClose={() => setShowModal(false)}
//                                     instanceData={selectedInstance} // Pass data here
//                                     editInstance={editInstance}
//                                     instances={instances}
//                                     instanceId={id}
                                   
//                                 />
//                             )}


//                         </>
//                     <div className="row">
//                     <div className="col-xl-12 col-lg-8">
//                                 <div className="card">
//                                     {/* Nav tabs */}
//                                     <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">
//                                         <li className="nav-item">
//                                             <WithTenanatPermission>
//                                             <a
//                                                 className={`nav-link ${activeTab === 'tenantList' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('tenantList')}
//                                                 role="tab"
//                                             >
//                                                 Tenants
//                                             </a>
//                                             </WithTenanatPermission>
//                                         </li>
//                                         <li className="nav-item">
//                                             <WithContactPermission>
//                                             <a
//                                                 className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('contactList')}
//                                                 role="tab"
//                                             >
//                                                 Contacts
//                                             </a>
//                                             </WithContactPermission>
//                                         </li>
//                                         <li className="nav-item">
//                                             <WithDocumentPermission>
//                                             <a
//                                                 className={`nav-link ${activeTab === 'document' ? 'active' : ''}`}
//                                                 onClick={() => {
//                                                     setActiveTab('document');
//                                                 }}                                               
//                                                  role="tab"
//                                             >
//                                                 Document
//                                             </a>
//                                             </WithDocumentPermission>
//                                         </li>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'instanceDetails' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('instanceDetails')}
//                                                 role="tab"
//                                             >
//                                                 Instance Details
//                                             </a>
//                                         </li>
                                        
//                                     </ul>
//                                     <div className="tab-content p-4">
//                                         {/* Contact List Tab */}
//                                         {activeTab === "contactList" && instanceDetails && (
//                                             <div className="tab-pane active" id="contact-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                 <SelectedContact instanceId={instanceDetails?.id}
//                                             entityType="instance"
//                                             fetchInstanceData={fetchInstanceDetails}
//                                             instanceData={instanceDetails}
//                                             setInstanceDetails={setInstanceDetails}
//                                             />
//                                                 </div>
//                                             </div>
//                                         )}
//                                          {activeTab === "tenantList" && instanceDetails && (
//                                             <div className="tab-pane active" id="tenant-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                 <TenantList instanceId={id} />

//                                                 </div>
//                                             </div>
//                                         )}
//                                          {activeTab === "document" && instanceDetails && (
//                                             <div className="tab-pane active" id="document-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                 <DocumentDetails instanceId={id}/>

//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "instanceDetails" && instanceDetails && (
//                                             <div className="tab-pane active" id="instacne-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                 <InstanceView instanceData={instanceDetails} setInstanceDetails={setInstanceDetails}/>
//                                                 </div>
//                                             </div>
//                                         )}
//                                         </div>
//                                     </div>
//                                     </div>
                      
//                     </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default InstanceDetail;


import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Offcanvas, Button, Row, Col } from 'react-bootstrap';
import {
    FaServer,
    FaBuilding,
    FaIdCard,
    FaCog,
    FaUsers,
    FaFileAlt,
    FaInfoCircle,
    FaGlobe
} from 'react-icons/fa';
import { BiPencil } from "react-icons/bi";
import { BsX } from "react-icons/bs";
import InstanceView from './InstanceView';
import DocumentDetails from '../DocumentDetails';
import TenantList from '../tenant/TenantList';
import SelectedContact from '../contact/SelectedContact';
import TenantDetail from '../tenant/TenantDetails';
import withPermission from '../../utils/withPermission';
import InstanceForm from './InstanceForm';
import TenantModal from '../tenant/TenantModal';
import ContactModal from '../contact/ContactModal';

const InstanceDetail = ({ show, onHide, instanceId }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") || "tenantList";
    
    const [instanceDetails, setInstanceDetails] = useState(null);
    const [activeTab, setActiveTab] = useState(initialTab);
    const [showModal, setShowModal] = useState(false);
    const [selectedInstance, setSelectedInstance] = useState(null);
    const [isChildModalOpen, setIsChildModalOpen] = useState(false);
    const [showTenantModal, setShowTenantModal] = useState(false);
    const [selectedTenantId, setSelectedTenantId] = useState(null);
    const [selectedTenantData, setSelectedTenantData] = useState(null);
    const [industries, setIndustries] = useState([]);
    const [showModalAfterClose, setShowModalAfterClose] = useState(false);
    const [modalInstanceData, setModalInstanceData] = useState(null);
    const [showTenantDetail, setShowTenantDetail] = useState(false);
    const [viewTenantId, setViewTenantId] = useState(null);
    const [showContactModal, setShowContactModal] = useState(false);
    const [selectedContact, setSelectedContact] = useState(null); // Added for lifting edit state
    const [isContactEdit, setIsContactEdit] = useState(false);     // Added for lifting edit state
    const [contactFormData, setContactFormData] = useState({ name: '', email: '', phone: '', position: '' }); // Added for lifting state
    const [contactErrors, setContactErrors] = useState({}); // Added to sync validation feedback
    const [domains, setDomains] = useState([]);

    const WithTenantPermission = withPermission(({ children }) => children, ['tenant-list']);
    const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
    const WithDocumentPermission = withPermission(({ children }) => children, ['document-list']);

    const didFetchRef = useRef(false);
    const contactRef = useRef();
    const contactSiblingRef = useRef();
    const documentRef = useRef();
    const documentSiblingRef = useRef();

    const [localShow, setLocalShow] = useState(show);
    const [showDocumentModal, setShowDocumentModal] = useState(false);

    // Sync with parent show prop
    useEffect(() => {
        setLocalShow(show);
    }, [show]);
    // Fetch instance details
    const fetchInstanceDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const currentId = instanceId || id;
            const response = await axios.get(`${backendUrl}/api/instance-info/${currentId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader:true,
            });

            setInstanceDetails(response.data);
        } catch (error) {
            console.error('Error fetching instance details:', error);
        }
    };

    // Edit instance function
    const editInstance = async (instanceId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/instance-info/${instanceId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader:true,
            });

            const updatedInstance = response.data?.Data || response.data?.data || response.data;

            if (updatedInstance) {
                setInstanceDetails((prevInstance) => ({
                    ...prevInstance,
                    ...updatedInstance,
                }));
            }

            setShowModal(false);
            return {}; // Return empty object on success
        } catch (error) {
            console.error('Error updating instance:', error);
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            }
            return { general: 'Failed to update instance' };
        }
    };

    const addTenant = async (newTenant) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const currentInstanceId = instanceId || id;
            const response = await axios.post(`${backendUrl}/api/tenants?instance_id=${currentInstanceId}`, newTenant, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            // Trigger fetch to refresh the list count and children
            fetchInstanceDetails();
            setShowTenantModal(false);
            return {};
        } catch (error) {
            console.error('Error adding tenant:', error);
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            }
            return { general: 'Failed to add tenant' };
        }
    };

    const editTenant = async (editId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/tenants/${editId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            // Refresh view
            fetchInstanceDetails();
            setShowTenantModal(false);
            return {};
        } catch (error) {
            console.error('Error updating tenant:', error);
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            }
            return { general: 'Failed to update tenant' };
        }
    };

    const fetchDomains = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/domain`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setDomains(response.data.Data.data || response.data.Data || []);
        } catch (error) {
            console.error('Error fetching domains:', error);
        }
    };

    // useEffect(() => {
    //     if (show) {
    //         fetchInstanceDetails();
    //     }
    // }, [show, instanceId]);


     useEffect(() => {
        if (localShow && instanceId) {
            setInstanceDetails(null); // Clear previous data
            fetchInstanceDetails();            
        }
    }, [localShow, instanceId]);

    useEffect(() => {
        setIsChildModalOpen(showTenantDetail || showTenantModal || showContactModal || showDocumentModal);
    }, [showTenantDetail, showTenantModal, showContactModal, showDocumentModal]);
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const handleOffcanvasClose = () => {
        setInstanceDetails(null);
        setActiveTab('tenantList');
        didFetchRef.current = false;
        onHide();
    };

    return (
        <>
        <Offcanvas
             show={localShow && !showModal && !isChildModalOpen}
            onHide={handleOffcanvasClose}
            placement="end"
            style={{ width: '1150px', zIndex: 1045 }} 
            className="Instance-offcanvas"
            unmountOnExit={false}
        >
            {/* Offcanvas Header */}
            <Offcanvas.Header className="border-bottom bg-white py-3">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center">
                        <div className="bg-primary rounded-circle p-2 me-3">
                            <FaServer className="text-white" size={18} />
                        </div>
                        <div>
                            <h5 className="mb-0 fw-bold text-dark">{instanceDetails?.setup_name}</h5>
                            <small className="text-muted">Instance ID: {instanceId || id}</small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <Button
                            variant="outline-primary"
                            size="sm"
                             onClick={() => {
                                setSelectedInstance(instanceDetails);
                                setShowModal(true);
                            }}
                        >
                            <BiPencil className="me-1" />
                            Edit Instance
                        </Button>

                        <Button
                            variant="light"
                            size="sm"
                            onClick={handleOffcanvasClose}
                            className="border-0"
                        >
                            <BsX size={20} />
                        </Button>
                    </div>
                </div>
            </Offcanvas.Header>

            {/* Offcanvas Body */}
            <Offcanvas.Body className="p-0">
                {/* Instance Summary Card */}
                <div className="p-4 border-bottom bg-light">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                    <FaIdCard className="text-primary" size={16} />
                                </div>
                                <div>
                                    <label className="text-muted small mb-1 d-block">Setup ID</label>
                                    <h6 className="mb-0 fw-semibold text-dark">
                                        {instanceDetails?.setup_id || 'Not assigned'}
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                    <FaCog className="text-primary" size={16} />
                                </div>
                                <div>
                                    <label className="text-muted small mb-1 d-block">Setup Mode</label>
                                    <h6 className="mb-0 fw-semibold text-dark">
                                        {instanceDetails?.setup_mode || 'Not specified'}
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                    <FaGlobe className="text-primary" size={16} />
                                </div>
                                <div>
                                    <label className="text-muted small mb-1 d-block">IP Address</label>
                                    <h6 className="mb-0 fw-semibold text-dark">
                                        {instanceDetails?.ip_address || 'Not assigned'}
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-start">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3 mt-1">
                                    <FaBuilding className="text-primary" size={16} />
                                </div>
                                <div className="flex-grow-1">
                                    <label className="text-muted small mb-1 d-block">Address</label>
                                    <div className="bg-white p-3 rounded border">
                                        <p className="mb-0 text-dark">
                                            {instanceDetails?.address || 'No address available for this instance.'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Navigation Tabs */}
                <div className="border-bottom bg-white">
                    <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                        <WithTenantPermission>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'tenantList' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('tenantList')}
                                    role="tab"
                                >
                                    <FaUsers className="me-2" size={14} />
                                    Tenants
                                    {instanceDetails?.tenants_count > 0 && (
                                        <span className="badge bg-primary ms-2">{instanceDetails.tenants_count}</span>
                                    )}
                                </button>
                            </li>
                        </WithTenantPermission>

                        <WithContactPermission>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('contactList')}
                                    role="tab"
                                >
                                    <FaUsers className="me-2" size={14} />
                                    Contacts
                                </button>
                            </li>
                        </WithContactPermission>

                        <WithDocumentPermission>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'document' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('document')}
                                    role="tab"
                                >
                                    <FaFileAlt className="me-2" size={14} />
                                    Documents
                                </button>
                            </li>
                        </WithDocumentPermission>

                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'instanceDetails' ? 'active' : ''}`}
                                onClick={() => handleTabClick('instanceDetails')}
                                role="tab"
                            >
                                <FaInfoCircle className="me-2" size={14} />
                                Instance Details
                            </button>
                        </li>
                    </ul>
                </div>

                {/* Tab Content */}
                <div className="tab-content p-4 bg-white" style={{ minHeight: '500px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
                    {/* Tenant List Tab */}
                    {activeTab === "tenantList" && instanceDetails && (
                        <div className="tab-pane active">
                            <TenantList 
                                instanceId={instanceId || id} 
                                onModalStateChange={setIsChildModalOpen}
                                onViewDetails={(id) => {
                                    setViewTenantId(id);
                                    setShowTenantDetail(true);
                                }}
                                onShowModal={(id, data) => {
                                    setSelectedTenantId(id);
                                    setSelectedTenantData(data);
                                    setShowTenantModal(true);
                                }}
                            />
                        </div>
                    )}

                    {/* Contact List Tab */}
                    {activeTab === "contactList" && instanceDetails && (
                        <div className="tab-pane active">
                            <SelectedContact
                                ref={contactRef}
                                instanceId={instanceDetails?.id}
                                entityType="instance"
                                fetchInstanceData={fetchInstanceDetails}
                                instanceData={instanceDetails}
                                setInstanceDetails={setInstanceDetails}
                                showContactModal={showContactModal}
                                setShowContactModal={setShowContactModal}
                                onShowModal={(isEdit, data) => {
                                    setIsContactEdit(isEdit);
                                    if (data) setContactFormData(data);
                                    else setContactFormData({ name: '', email: '', phone: '', position: '' });
                                    setShowContactModal(true);
                                    if (contactSiblingRef.current) {
                                        contactSiblingRef.current.setIsEdit(isEdit);
                                        contactSiblingRef.current.setFormData(data || { name: '', email: '', phone: '', position: '' });
                                    }
                                }}
                            />
                        </div>
                    )}

                    {/* Document Tab */}
                    {activeTab === "document" && instanceDetails && (
                        <div className="tab-pane active">
                            <DocumentDetails 
                                ref={documentRef}
                                instanceId={instanceId || id} 
                                documentableType="instance"
                                onModalStateChange={setShowDocumentModal}
                                onShowModal={(isEdit, data) => {
                                    if (documentSiblingRef.current) {
                                        documentSiblingRef.current.setIsEdit(isEdit);
                                        documentSiblingRef.current.setFormData(data);
                                        documentSiblingRef.current.setShowModal(true);
                                    }
                                    setShowDocumentModal(true);
                                }}
                            />
                        </div>
                    )}

                    {/* Instance Details Tab */}
                    {activeTab === "instanceDetails" && (
                        <div className="tab-pane active">
                            {instanceDetails ? (
                                <InstanceView
                                    instanceData={instanceDetails}
                                    setInstanceDetails={setInstanceDetails}
                                />
                            ) : (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2 text-muted">Loading instance details...</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </Offcanvas.Body>

        </Offcanvas>

        {/* Tenant Details Sub-Offcanvas */}
        <TenantDetail 
            show={showTenantDetail} 
            onHide={() => {
                setShowTenantDetail(false);
                setTimeout(() => setViewTenantId(null), 350);
            }} 
            tenantId={viewTenantId}
        />

        {/* Contact Add/Edit Modal */}
        {showContactModal && (
            <ContactModal
                showModal={showContactModal}
                handleClose={() => setShowContactModal(false)}
                isEdit={isContactEdit}
                formData={contactFormData}
                handleInputChange={(e) => {
                    const { name, value } = e.target;
                    setContactFormData(prev => ({ ...prev, [name]: value }));
                }}
                handleSubmit={async () => {
                   // Usually the child SelectedContact handles this, but since we lifted it,
                   // we can either pass a ref or just trigger a refresh in the child.
                   // For now, let's keep it simple.
                }}
            />
        )}
        {/* Headless Contact Implementation for Sibling Modal */}
        <SelectedContact 
            ref={contactSiblingRef}
            instanceId={instanceId || id}
            entityType="instance"
            hideList={true}
            setInstanceDetails={setInstanceDetails}
            showContactModal={showContactModal}
            setShowContactModal={setShowContactModal}
        />
        {/* Document Add/Edit Modal (as Sibling) */}
        <DocumentDetails 
            ref={documentSiblingRef}
            instanceId={instanceId || id} 
            hideList={true} 
            documentableType="instance"
            onModalStateChange={setShowDocumentModal}
        />
        {/* Contact Add/Edit Modal (handled by InstanceDetails sibling render) */}
        {showContactModal && (
            <ContactModal
                showModal={showContactModal}
                handleClose={() => setShowContactModal(false)}
                isEdit={isContactEdit}
                formData={contactFormData}
                handleInputChange={(e) => {
                    const { name, value } = e.target;
                    setContactFormData(prev => ({ ...prev, [name]: value }));
                    setContactErrors(prev => {
                        const newErrors = { ...prev };
                        delete newErrors[name];
                        return newErrors;
                    });
                    if (contactSiblingRef.current) contactSiblingRef.current.handleManualInputChange(e);
                }}
                errors={contactErrors}
                handleSubmit={async () => {
                    if (contactSiblingRef.current) {
                        try {
                            const result = await contactSiblingRef.current.handleSubmit(contactFormData);
                            if (result && !result.success) {
                                setContactErrors(result.errors || {});
                            }
                        } catch (err) {
                            console.error("Save failure:", err);
                        }
                    }
                }}
            />
        )}
        {/* Tenant Add/Edit Modal */}
        {showTenantModal && (
            <TenantModal
                showModal={showTenantModal}
                handleClose={() => {
                   setShowTenantModal(false);
                   setSelectedTenantId(null);
                   setSelectedTenantData(null);
                }}
                tenantId={selectedTenantId}
                tenantData={selectedTenantData}
                addTenant={addTenant}
                editTenant={editTenant}
                instanceId={instanceId || id}
                industries={industries}
                fetchIndustries={async () => {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;
                    const response = await axios.get(`${backendUrl}/api/industries`, {
                        headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin },
                        skipLoader: true,
                    });
                    setIndustries(response.data.industry || []);
                }}
                domains={domains}
                fetchDomains={fetchDomains}
            />
        )}
        {/* Instance Modal */}
        {showModal && (
            <InstanceForm
                showModal={showModal}
                handleClose={() => setShowModal(false)}
                instanceData={selectedInstance}
                editInstance={editInstance}
                instanceId={instanceId || id}
            />
        )}
        </>
    );
};

export default InstanceDetail;
